import React, { useEffect } from "react";
import Column from "@amzn/meridian/column";
import { IFiltersProps } from "./definitions";
import { FilterSelect } from "./FilterSelect";
import { FilterDateRange } from "./FilterDateRange";
import { FilterInputRange } from "./FilterInputRange";
import { FilterInput } from "./FilterInput";
import Button from "@amzn/meridian/button";
import { useFilterSheets } from "./hooks";
import { FilterSelectSearch } from "./FilterSelectSearch";
import { useAppDispatch } from "../../app/store/hooks";

export const Filters: React.FC<IFiltersProps> = ({ filters, resetButton }) => {
    const dispatch = useAppDispatch();
    const { resetFilters, setFilterSheetsOpen } = useFilterSheets();

    useEffect(() => {
        dispatch(setFilterSheetsOpen(true));

        return () => {
            dispatch(setFilterSheetsOpen(false));
        };
    }, []);

    return (
        <Column width={"100%"} spacing={"400"}>
            {filters.map(filter => {
                switch (filter.type) {
                    case "SELECT":
                        return <FilterSelect selectOptions={filter} />;
                    case "SELECT_SEARCH":
                        return <FilterSelectSearch selectOptions={filter} />;
                    case "INPUT_RANGE":
                        return <FilterInputRange inputRangeInfo={filter} />;
                    case "DATE_RANGE":
                        return <FilterDateRange dateRangeInfo={filter} />;
                    case "INPUT":
                        return <FilterInput inputInfo={filter} />;
                    case "DISPLAY_AS_TEXT":
                        return <FilterInput inputInfo={filter} />;
                }
            })}
            {resetButton && (
                <Button onClick={resetFilters} type="link">
                    Reset Filters
                </Button>
            )}
        </Column>
    );
};
